import {createSlice} from '@reduxjs/toolkit';
import {CaseDetailsDto} from 'src/shared/services/patient/dto/case/case-details-dto';

interface CasesInitialState {
  casesList: Array<CaseDetailsDto> | undefined;
  caseDetails: CaseDetailsDto | undefined;
  isCasesListLoading: boolean | undefined;
}

const initialState: CasesInitialState = {
  casesList: [],
  caseDetails: undefined,
  isCasesListLoading: false,
};

const casesSlice = createSlice({
  name: 'cases',
  initialState: initialState,
  reducers: {
    setCasesList: (state, action) => {
      state.casesList = action.payload;
    },
    setCaseDetails: (state, action) => {
      state.caseDetails = action.payload;
    },
    setIscasesListLoading: (state, action) => {
      state.isCasesListLoading = action.payload;
    },
  },
});

export const {setCasesList, setCaseDetails, setIscasesListLoading} =
  casesSlice.actions;

export default casesSlice.reducer;
